import { useHandleFilters } from "../projectFilters/handleFilters";

/**
 * Execute the search projects and BAG.
 *
 * @param {Object} element
 */
export default (element) => {
    const pagetype = element.element.dataset.pagetype;
    const searchInput = element.element.querySelector('.search input');
    const resultId = '#searchResults';
    const searchBtn = element.element.querySelector('.search button');
    const projectFiltersSection = document.querySelector('[data-features="project-filters"]');
    let searchApiUrl = `${window.location.origin}/api/search`;

    let timer = '';
    let lastRequest = '';
    let urlFilters = [];
    let pageNewBuildUrl =  element.element.dataset.pageNewBuildUrl;
    if (pageNewBuildUrl === 'undefined') {
        pageNewBuildUrl = '';
    }

    // Add query search value to input field
    const urlParams = new URLSearchParams(window.location.search);
    searchInput.value = urlParams.get('query');

    const {
        handlePrefilledInputs,
        getUrlFilters,
        setUrlFilters,
        handleSubmitFilters,
        setBaseUrl,
    } = useHandleFilters();

    if(pagetype === 'project') {
        searchApiUrl = `${window.location.origin}/api/search`;
    }
    if(pagetype === 'news') {
        searchApiUrl = `${window.location.origin}/api/news`;
    }

    const init = () => {
        // Set search value from url
        let urlParams = window.location.pathname.split('/');
        urlParams.forEach((param) => {
            const parts = param.split('-');
            if (parts[0] === 'zoeken') {
                searchInput.value = decodeURIComponent(parts[1]); // parse string to replace %20 with a space
            }
        });

        // When on project overview page load all the filters to keep filters when a new search is submitted
        if (projectFiltersSection) {
            handlePrefilledInputs();
            setBaseUrl(pageNewBuildUrl);
            urlFilters = getUrlFilters();
        }

        setListeners();
    };

    const setListeners = () => {
        searchInput.addEventListener('keyup', (event) => {
            // Enter key
            if (event.keyCode === 13) {
                submitSearch();
                // Don't stop on search, instead redirect to ?query=...
                return true;
            }
            event.preventDefault();
            event.stopPropagation();

            // Escape key
            if (event.keyCode === 27) {
                hideResults();
            }

            // Call search api
            const alreadyMappedKeys = [13, 27, 37, 38, 39, 40];
            if (!alreadyMappedKeys.includes(event.keyCode)) {
                if (searchInput.value.length > 1) {
                    clearTimeout(timer);
                    timer = setTimeout(function (event) {
                        hideResults();
                        sendApiCall.call();
                    }, 500);
                } else if (searchInput.value.length === 0) {
                    timer = setTimeout(function () {
                        hideResults();
                    }, 500);
                }
            }
        });
        searchBtn.addEventListener('click', (event) => {
            submitSearch();
        });
        document.addEventListener('click', function (event) {
            const searchResults = document.getElementById('searchResults');
            // Check if the click target is outside the searchResults
            if (searchResults && !searchResults.contains(event.target)) {
                // Clicked outside the searchResults, hide them
                hideResults();
            }
        });
    };

    const sendApiCall = () => {
        // If there's a previous request, abort it
        if (lastRequest && lastRequest.readyState !== 4) {
            lastRequest.abort();
        }

        lastRequest = $.ajax({
            url: searchApiUrl,
            method: 'POST',
            data: {
                query: searchInput.value,
            },
            success: function (data) {
                formatResults(data.data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error(errorThrown);
            }
        });
    };

    const cleanUrlFilters = () => {
        let currentFilters = window.location.pathname.split('/');
        let excludedArray = [
            'koop','huur','prijs',
            'actueel','binnenkort','toekomstig',
            'woonoppervlakte','perceeloppervlakte',
            'huis','appartement','kavel',
            'woningtype','slaapkamers',
            'sinds','kaart','thema'
        ];
        let filteredArray = currentFilters.filter(value => {
            let originalArrayItem = value.split('-');
            return excludedArray.includes(originalArrayItem[0]);
        });
        return '/' + filteredArray.join('/');
    }

    const formatResults = (data) => {
        let regex = new RegExp(searchInput.value, 'gi');
        let found = 0;
        let html = '<ul>';
        const searchValue = encodeURIComponent(searchInput.value);

        let resultString = cleanUrlFilters();

        $.each(data.results, function (index, item) {
            if (item.count > 0) {
                found++;
                html += '<li class="text-primary">';
                html += item.name;
                html += '<span class="pull-right">(' + item.count + ')</span>';
                html += '<ul>';
                $.each(item.items, function (index, object) {
                    if(!object.projects_count){
                        html += '<li class="searchItem"><a href="' + object.apiUrlAction + '">' + object.searchresult.replace(regex, '<span style="font-weight: bold;">$&</span>') + '</a></li>';
                    } else {
                        html += '<li class="searchItem"><a href="' + object.apiUrlAction + resultString +'">' + object.searchresult.replace(regex, '<span style="font-weight: bold;">$&</span>') + '</a></li>';
                    }
                });
                if (index === 'projects' && item.count > item.items.length) {
                    html += `<li class="searchItem"><a class="searchItem--showMore" href="${pageNewBuildUrl}/zoeken-${searchValue}" >Meer resultaten</a></li>`;
                }
                html += '</ul>';

                html += '</li>';
            }
        });

        if (found === 0)
            html += '<li>Er zijn geen resultaten gevonden</li>'

        html += '</ul>';
        $(resultId).html(html).height()
        showResults();
    }

    const submitSearch = () => {
        if (projectFiltersSection) {
            submitWithFilters();
        } else if (pageNewBuildUrl) {
            let resultString = cleanUrlFilters();
            // first a api call has to be made to know the url of project overview
            const searchValue = encodeURIComponent(searchInput.value);
            window.location.href = `${pageNewBuildUrl}/zoeken-${searchValue}`+resultString;
        }
    }

    const submitWithFilters = () => {
        let resultString = cleanUrlFilters();

        urlFilters = urlFilters.filter((param) => {
            const parts = param.split('-');
            return parts[0] !== 'zoeken';
        });

        if(searchInput.value.length > 0){
            urlFilters.push(`zoeken-${searchInput.value}`);
            urlFilters.push(resultString);
        }
        setUrlFilters(urlFilters);
        handleSubmitFilters();
    };

    const showResults = () => {
        $(resultId).fadeIn();
    }

    const hideResults = () => {
        $(resultId).fadeOut();
    }

    init();
};
